import { CLEAR_ERRORS } from './type';

export const clearErrors = () => {
    return function (dispatch) {
        dispatch({
            type: CLEAR_ERRORS,
        });
    };
};
